import { render, staticRenderFns } from "./ProducersTable.vue?vue&type=template&id=0cdd9330&"
import script from "./ProducersTable.vue?vue&type=script&lang=js&"
export * from "./ProducersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports